// Mock data for question types selection with improved descriptions
import {QuestionType} from "crqlar-react-common/dist/models/forms/form";

export const questionTypes = [
    {
        id: 'welcome',
        type: QuestionType.WELCOME,
        name: 'Welcome or Info Screen',
        description: 'Create an engaging introduction to your fitness assessment',
        icon: 'smart_display',
        color: '#4FD1C5'
    },
    {
        id: 'multiple_choice',
        type: QuestionType.MULTIPLE_CHOICE,
        name: 'Multiple Choice',
        description: 'Great for goals, preferences, and training habits',
        icon: 'check_box',
        color: '#D53F8C'
    },
    {
        id: 'picture_choice',
        type: QuestionType.PICTURE_CHOICE,
        name: 'Picture Choice',
        description: 'Visual selection for exercise types and environments',
        icon: 'image',
        color: '#805AD5'
    },
    {
        id: 'yes_no',
        type: QuestionType.YES_NO,
        name: 'Yes/No',
        description: 'Quick binary questions for health screening and preferences',
        icon: 'toggle_on',
        color: '#B794F4'
    },
    {
        id: 'dropdown',
        type: QuestionType.DROPDOWN,
        name: 'Dropdown',
        description: 'Ideal for frequency, intensity, and duration questions',
        icon: 'arrow_drop_down',
        color: '#90CDF4'
    },
    {
        id: 'short_text',
        type: QuestionType.SHORT_TEXT,
        name: 'Short Text',
        description: 'Collect specific metrics like weight, height, or age',
        icon: 'short_text',
        color: '#63B3ED'
    },
    {
        id: 'long_text',
        type: QuestionType.LONG_TEXT,
        name: 'Long Text',
        description: 'For detailed health history and training background',
        icon: 'text_fields',
        color: '#63B3ED'
    },
    {
        id: 'legal',
        type: QuestionType.LEGAL,
        name: 'Legal',
        description: 'Health disclaimers and training agreement acceptance',
        icon: 'gavel',
        color: '#90CDF4'
    },
    {
        id: 'rating',
        type: QuestionType.RATING,
        name: 'Rating',
        description: 'Scale-based assessment for energy, mood, or workout intensity',
        icon: 'star',
        color: '#F6AD55'
    },
    {
        id: 'upload_media',
        type: QuestionType.UPLOAD_MEDIA,
        name: 'Upload Media',
        description: 'Collect photos, videos, or documents from clients',
        icon: 'cloud_upload',
        color: '#48BB78'
    },
    {
        id: 'end_screen',
        type: QuestionType.END_SCREEN,
        name: 'End Screen',
        description: 'Set expectations for next steps in the fitness journey',
        icon: 'celebration',
        color: '#F6AD55'
    }
];